import { useMe } from './hooks'

/** True when the viewer is this athlete or running local dev: plans, lifts and settings are theirs. */
export function useOwnsAthlete(athleteId: string | null | undefined): boolean {
  const { data: me } = useMe()
  if (!me || !athleteId) return false
  return me.dev || me.access.some((a) => a.athleteId === athleteId && a.own)
}
